<h1 mat-dialog-title>
    <span *ngIf="data.title; else elseBlock">{{data.title}}</span>
    <ng-template #elseBlock><span>Add Item</span></ng-template>
</h1>

<div mat-dialog-content>
    <mat-form-field>
        <mat-chip-grid #chipList aria-label="Item selection">
            <mat-chip-row
                *ngFor="let item of items"
                [editable]="selectable"
                [removable]="removable"
                (removed)="removeItem(item)"
            >
                {{ item.name }} ({{ item.tag }}) <mat-icon *ngIf="removable" matChipRemove>cancel</mat-icon>
            </mat-chip-row>
            <input
                #itemInput
                [attr.data-testid]="'add_item_text'"
                [disabled]="tagExists"
                [formControl]="input"
                [matAutocomplete]="auto"
                [matChipInputFor]="chipList"
                matInput
                ngModel="input"
                placeholder="Start typing"
                (paste)="onPaste($event)"
            />
        </mat-chip-grid>
    </mat-form-field>
    <div *ngIf="tagExists" class="mat-error">
        {{ errorMessage }}
    </div>
    <mat-autocomplete
        #auto="matAutocomplete"
        autoActiveFirstOption="true"
        [displayWith]="displayFn"
        panelWidth="555px"
        (optionSelected)="itemSelected($event)"
    >
        <mat-option
            *ngFor="let option of options"
            [attr.data-testid]="option.name + '_option'"
            [value]="option"
        >{{ option.name }} ({{ option.tag }})</mat-option>
    </mat-autocomplete>
    <div class="toggle-question" *ngIf="displayAddGlobal">
        <mat-slide-toggle
            [attr.data-testid]="'add_global_toggle'"
            [formControl]="addGlobal"
        ><span class="toggle-label">Add Global</span></mat-slide-toggle>
    </div>
</div>
<div mat-dialog-actions>
    <button
        [attr.data-testid]="'cancel_button'"
        mat-raised-button
        matTooltip="Cancel"
        class="button-color"
        (click)="cancelAddItem()"
    >Cancel</button>
    <button
        [attr.data-testid]="'ok_button'"
        class="button-color"
        [disabled]="items.length === 0 || tagExists || (isReadOnly$ | async)"
        mat-raised-button
        matTooltip="Save"
        (click)="addItem()"
    >Ok</button>
</div>
